var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.published)?_c('button',{key:"publish",staticClass:"btn btn-success w-full",attrs:{"disabled":_vm.loading},on:{"click":_vm.doPublish}},[_vm._v(" Publish ")]):_c('button',{key:"unpublish",staticClass:"btn btn-danger w-full",attrs:{"disabled":_vm.loading},on:{"click":_vm.doUnpublish}},[_vm._v(" Unpublish ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }